module.exports = __webpack_public_path__ + "static/media/bg.cbf24278.jpg";